import { useMemo } from "react";

import { isCookieAuth } from "../../../../../lib/authProvider";
import { GOALS_PORTFOLIO_STORES } from "../../constants";
import { usePortfolioStores } from "../shared/Storepicker";

// The stores an "All stores" goals view fans out over.
export const useGoalsStores = () => {
  const stores = usePortfolioStores(GOALS_PORTFOLIO_STORES);
  return useMemo(() => {
    // On the cookie path "all" is the goals portfolio narrowed to the user's
    // grants, so it never names a store the user cannot reach.
    if (isCookieAuth()) {
      return stores
        .map((store) => store.value)
        .filter((value) => value && value !== "all");
    }
    // The legacy email map mixes client stores into "all", which the goals
    // budget excludes, so this path uses the fixed portfolio instead.
    return GOALS_PORTFOLIO_STORES;
  }, [stores]);
};
